import state from '@/core/state';

// Default 3 decimals; prefer API/merchant setting when present.
export function getPointDecimals() {
    const info = state.memberInfo || {};
    const merchant = info.merchant_info || {};
    const raw = info.point_decimal ?? info.decimal ?? merchant.point_decimal ?? merchant.decimal ?? 3;
    const decimals = Number(raw);
    return Number.isFinite(decimals) && decimals >= 0 ? Math.min(Math.floor(decimals), 8) : 3;
}

export function floorPoint(value, decimals = getPointDecimals()) {
    const point = parseFloat(value);
    if (!Number.isFinite(point)) return 0;
    const factor = 10 ** decimals;
    return Math.floor(Number((point * factor).toFixed(8))) / factor;
}

export function roundPoint(value, decimals = getPointDecimals()) {
    const point = parseFloat(value);
    if (!Number.isFinite(point)) return 0;
    const factor = 10 ** decimals;
    return Math.round(Number((point * factor).toFixed(8))) / factor;
}

export function formatPoint(value, decimals = getPointDecimals()) {
    return roundPoint(value, decimals).toFixed(decimals);
}
